interface OutcomeRange {
  title: string;
  moreThanValue: string | null;
  lessThanValue: string | null;
}

export function validateEventOutcomes(outcomes: OutcomeRange[]): void {
  if (!Array.isArray(outcomes) || outcomes.length === 0) {
    throw new Error('eventOutcomes must not be empty');
  }

  const ranges = outcomes.map((o) => {
    const min =
      o.moreThanValue !== null && o.moreThanValue !== '' ?
        Number(o.moreThanValue)
      : -Infinity;
    const max =
      o.lessThanValue !== null && o.lessThanValue !== '' ?
        Number(o.lessThanValue)
      : Infinity;

    if (min >= max) {
      throw new Error(`Invalid range in outcome "${o.title}"`);
    }

    return { min, max, title: o.title };
  });

  ranges.sort((a, b) => a.min - b.min);

  if (ranges[0].min !== -Infinity) {
    throw new Error('Ranges must start from -Infinity');
  }

  for (let i = 0; i < ranges.length - 1; i++) {
    const current = ranges[i];
    const next = ranges[i + 1];

    if (Math.abs(current.max - next.min) > 0.000001) {
      throw new Error(
        `Gap or overlap between "${current.title}" (${current.max}) and "${next.title}" (${next.min})`,
      );
    }
  }

  if (ranges[ranges.length - 1].max !== Infinity) {
    throw new Error('Ranges must end with Infinity');
  }
}
